import { render, staticRenderFns } from "./collapse.vue?vue&type=template&id=05a022c0&"
import script from "./collapse.vue?vue&type=script&lang=js&"
export * from "./collapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "collapse.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/base/collapse/collapse.vue
// module id = 108
// module chunks = 0